module.exports = __webpack_public_path__ + "c356896ee75d6bdf7071727c048196f2.svg";